import { getTime } from '@/utils/index.js';

let timeReq = 0;
let timeRes = 0;

export default {
  setupInterceptors: instance => {
    instance.interceptors.request.use(
      function (config) {
        const shouldDelay = config?.shouldDelay;
        timeReq = getTime();

        return {
          ...config,
          shouldDelay,
        };
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      async response => {
        if (response.data) {
          timeRes = getTime();

          const {shouldDelay} = response.config;
          const minimumDelay = 700;
          const range = timeRes - timeReq;

          if (!shouldDelay || range >= minimumDelay) {
            return response.data;
          }

          const remainder = minimumDelay - range;
          const [responseWithDelay] = await Promise.all([
            response,
            new Promise(resolve => setTimeout(resolve, remainder)),
          ]);

          return responseWithDelay.data;
        }
        return Promise.reject();
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  },
};
